import React, { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import useDisableBrowserBack from "../../hooks/useDisableBrowserBack";
import useReadCookies from "../../hooks/useReadCookies";
import { getGameStatus } from '../gameSlice';
import { getUserColor } from '../../../utils/index';

function MissionSummary() {
  useDisableBrowserBack();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  let { cookieGroupId } = useReadCookies();

  const lastMission = useSelector((state) => state.game.currentMission);
  const groupScore = useSelector((state) => state.game.groupScore);
  const missions = useSelector((state) => state.game.missions);
  const players = useSelector((state) => state.game.players);

  const [passedMissionsLength, setPassedMissionsLength] = useState(0);
  const [collectablesLength, setCollectablesLength] = useState();
  const [unlockedCollectablesLength, setUnlockedCollectablesLength] = useState(0);
  const [currentScreen, setCurrentScreen] = useState(0);
  const [startTransition, setStartTransition] = useState(false);

  const mobileContainerRef = useRef(null);

  useEffect(() => {
    document.querySelector('meta[name="theme-color"]').setAttribute('content', '#292929');
    dispatch(getGameStatus(cookieGroupId));
  }, []);

  useEffect(() => {
    let passedMissions = 0;
    let unlockedCollectables = 0;

    if (missions.length) {
      missions.forEach(mission => {
        if (mission.mission_passed) passedMissions++;
        if (mission.mission_passed) unlockedCollectables++;
        if (mission.swipe_finished) unlockedCollectables++;
        if (mission.mix_n_match_finished) unlockedCollectables++;
      });
      setPassedMissionsLength(passedMissions);
      setCollectablesLength(missions.length * 3);
      setUnlockedCollectablesLength(unlockedCollectables);
    }
    const timing = 8000 + (passedMissions * 1000);
    const animOutTimeout = setTimeout(() => {setStartTransition(true)}, timing - 1000);
    const nextScreenTimeout = setTimeout(() => {
      setStartTransition(false);
      setCurrentScreen(1);
    }, timing);
    return () => {
      clearTimeout(animOutTimeout);
      clearTimeout(nextScreenTimeout);
    }
  }, [missions])

  const handleContinueButton = (e) => {
    e.preventDefault();
    navigate("/app/game/groupsSummary" + window.location.search);
  }

  return (
    <div className="mobileContainer backgroundPaper missions-summary-screen" ref={mobileContainerRef}>
      <div className="summary-wrapper">
        <div className="title-wrapper">
          <h3>Jullie score</h3>
        </div>
        <div className="result-container mission-progress-container">
          <div className="background-circle-container centered-square">
            <div className="background-circle"></div>
          </div>
          {(currentScreen === 0) &&
            <>
              <div className={`score-progress-anchor centered-square ${startTransition ? 'out-animation' : ''}`}>
                <div className="circle-shadow"></div>
                <div className={`score-progress`}>
                  {missions && missions.map((mission, index) => (
                    <div className="progress-step-container" style={{ '--total': missions.length, '--index': index }} key={index}>
                      <div className={`progress-step ${mission.finished ? 'finished' : ''} ${mission.mission_passed ? 'win' : 'fail'}`}>
                        <div className="step">
                          <div className="number">{index + 1}</div>
                        </div>
                        {(mission.finished && !mission.mission_passed) &&
                          <div className="step empty">
                            <div className="number">{index + 1}</div>
                          </div>
                        }
                        {mission.mission_passed &&
                          <div className="step medal">
                            <div className="number">{index + 1}</div>
                          </div>
                        }
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className={`score-circle-anchor centered-square ${startTransition ? 'out-animation' : ''}`}>
                <div className={`score-circle`}>
                  <div className="score-number">
                    <span className="anchor">{passedMissionsLength}</span>
                  </div>
                  <div className="score-label">
                    <span className="anchor">Behaalde missies</span>
                  </div>
                </div>
              </div>
            </>
          }
          {(currentScreen === 1) &&
            <>
              <div className="abstract-circle centered-square">
                <div className="background-circle"></div>
              </div>
              <div className="score-progress-anchor collectable-progress-anchor centered-square">
                <div className="circle-shadow"></div>
                <div className="score-progress collectable-progress">
                {Array(collectablesLength).fill().map((_, index) => (
                    <div className="progress-step-container" style={{ '--total': collectablesLength, '--index': index }} key={index}>
                      <div className={`progress-step`}>
                        <div className="step"></div>
                        {(index < unlockedCollectablesLength) &&
                          <div className="step medal"></div>
                        }
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="score-circle-anchor centered-square">
                <div className="score-circle">
                  <div className="score-number">
                    <span className="anchor">{unlockedCollectablesLength}</span>
                  </div>
                  <div className="score-label">
                    <span className="anchor">Behaalde munten</span>
                  </div>
                </div>
              </div>
            </>
          }
        </div>
      </div>
      <div className={`navigationDrawer spread variant6 enableInAnimation`}>
        <span>&nbsp;</span>
        <a className="chromelessIconButton" onClick={handleContinueButton}>
          <span className="caption">{t('student.missions_overview.button_text')}</span>
          <span className="icon icon-forward"></span>
        </a>
      </div>
      <div className="group-avatar">
        <img src={`/storage/avatar/group_${cookieGroupId}.png`} />
      </div>
    </div>
  );
}

export default MissionSummary;